package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.CalendarMonthW500RoundedFill: ImageVector
    get() {
        if (_calendarMonthW500RoundedFill != null) {
            return _calendarMonthW500RoundedFill!!
        }
        _calendarMonthW500RoundedFill = Builder(name = "CalendarMonthW500RoundedFill", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(202.87f, 888.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-554.26f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                lineTo(240.0f, 151.87f)
                verticalLineToRelative(-37.37f)
                quadToRelative(0.0f, -17.96f, 12.46f, -30.29f)
                quadToRelative(12.45f, -12.34f, 30.41f, -12.34f)
                reflectiveQuadToRelative(30.29f, 12.34f)
                quadToRelative(12.34f, 12.33f, 12.34f, 30.29f)
                verticalLineToRelative(37.37f)
                horizontalLineToRelative(309.0f)
                verticalLineToRelative(-37.37f)
                quadToRelative(0.0f, -17.96f, 12.46f, -30.29f)
                quadToRelative(12.45f, -12.34f, 30.41f, -12.34f)
                reflectiveQuadToRelative(30.29f, 12.34f)
                quadTo(720.0f, 96.54f, 720.0f, 114.5f)
                verticalLineToRelative(37.37f)
                horizontalLineToRelative(37.13f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(554.26f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(202.87f, 888.13f)
                close()
                moveTo(202.87f, 797.13f)
                horizontalLineToRelative(554.26f)
                lineTo(757.13f, 400.0f)
                lineTo(202.87f, 400.0f)
                verticalLineToRelative(397.13f)
                close()
                moveTo(480.0f, 561.91f)
                quadToRelative(-17.72f, 0.0f, -29.82f, -12.09f)
                quadToRelative(-12.09f, -12.1f, -12.09f, -29.82f)
                reflectiveQuadToRelative(12.09f, -29.82f)
                quadToRelative(12.1f, -12.09f, 29.82f, -12.09f)
                reflectiveQuadToRelative(29.82f, 12.09f)
                quadToRelative(12.09f, 12.1f, 12.09f, 29.82f)
                reflectiveQuadToRelative(-12.09f, 29.82f)
                quadToRelative(-12.1f, 12.09f, -29.82f, 12.09f)
                close()
                moveTo(290.18f, 549.82f)
                quadToRelative(-12.09f, -12.1f, -12.09f, -29.82f)
                reflectiveQuadToRelative(12.09f, -29.82f)
                quadToRelative(12.1f, -12.09f, 29.82f, -12.09f)
                reflectiveQuadToRelative(29.82f, 12.09f)
                quadToRelative(12.09f, 12.1f, 12.09f, 29.82f)
                reflectiveQuadToRelative(-12.09f, 29.82f)
                quadToRelative(-12.1f, 12.09f, -29.82f, 12.09f)
                reflectiveQuadToRelative(-29.82f, -12.09f)
                close()
                moveTo(640.0f, 561.91f)
                quadToRelative(-17.48f, 0.0f, -29.7f, -12.09f)
                quadToRelative(-12.21f, -12.1f, -12.21f, -29.82f)
                reflectiveQuadToRelative(12.21f, -29.82f)
                quadToRelative(12.22f, -12.09f, 29.7f, -12.09f)
                quadToRelative(17.72f, 0.0f, 29.82f, 12.09f)
                quadToRelative(12.09f, 12.1f, 12.09f, 29.82f)
                reflectiveQuadToRelative(-12.09f, 29.82f)
                quadToRelative(-12.1f, 12.09f, -29.82f, 12.09f)
                close()
                moveTo(480.0f, 721.91f)
                quadToRelative(-17.72f, 0.0f, -29.82f, -12.21f)
                quadToRelative(-12.09f, -12.22f, -12.09f, -29.7f)
                quadToRelative(0.0f, -17.72f, 12.09f, -29.82f)
                quadToRelative(12.1f, -12.09f, 29.82f, -12.09f)
                reflectiveQuadToRelative(29.82f, 12.09f)
                quadToRelative(12.09f, 12.1f, 12.09f, 29.82f)
                quadToRelative(0.0f, 17.48f, -12.09f, 29.7f)
                quadToRelative(-12.1f, 12.21f, -29.82f, 12.21f)
                close()
                moveTo(290.18f, 709.7f)
                quadToRelative(-12.09f, -12.22f, -12.09f, -29.7f)
                quadToRelative(0.0f, -17.72f, 12.09f, -29.82f)
                quadToRelative(12.1f, -12.09f, 29.82f, -12.09f)
                reflectiveQuadToRelative(29.82f, 12.09f)
                quadToRelative(12.09f, 12.1f, 12.09f, 29.82f)
                quadToRelative(0.0f, 17.48f, -12.09f, 29.7f)
                quadToRelative(-12.1f, 12.21f, -29.82f, 12.21f)
                reflectiveQuadToRelative(-29.82f, -12.21f)
                close()
                moveTo(640.0f, 721.91f)
                quadToRelative(-17.48f, 0.0f, -29.7f, -12.21f)
                quadToRelative(-12.21f, -12.22f, -12.21f, -29.7f)
                quadToRelative(0.0f, -17.72f, 12.21f, -29.82f)
                quadToRelative(12.22f, -12.09f, 29.7f, -12.09f)
                quadToRelative(17.72f, 0.0f, 29.82f, 12.09f)
                quadToRelative(12.09f, 12.1f, 12.09f, 29.82f)
                quadToRelative(0.0f, 17.48f, -12.09f, 29.7f)
                quadToRelative(-12.1f, 12.21f, -29.82f, 12.21f)
                close()
            }
        }
        .build()
        return _calendarMonthW500RoundedFill!!
    }

private var _calendarMonthW500RoundedFill: ImageVector? = null
